import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import router from '../../main'

const REPORT_DOMAIN = process.env.VUE_APP_REPORT_DOMAIN || 'https://smartreport.test.17zuoye.net/'

@Component
export default class AssessmentMenu extends Vue {
  private get current() {
    return [this.$route.meta.name]
  }
  private get subjectId() {
    return this.$store.state.subject.value
  }
  private get userInfo() {
    const user = this.$store.state.user_info
    return user && user
  }
  public menu = router
  public selectedKeys: any = ['list']
  public openKeys: any = ['myassessment']
  public handleSelect(e) {
    this.$router.push({ path: `/myassessment/${e.key}` })
  }
  public handleClick(e) {
    if (e.key === 'report') {
      this.toReportlist()
      setTimeout(() => {
        this.$router.back()
      }, 50)
    }
  }
  public toReportlist() {
    window['sensors'].track('TIKU_Assessment_viewreport ', { buttonName: '校级测评报告' })
    window.open(REPORT_DOMAIN + '/vox-17xue/groupReport')
  }
  public showMenuItem(item) {
    if (item.meta.allowSubjects === 'all' || item.meta.allowSubjects.includes(this.subjectId)) {
      if (item.meta.section === '校级测评') {
        if (this.userInfo && this.userInfo.subjectLeaders && this.userInfo.subjectLeaders.length > 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    } else {
      return false
    }
  }
  @Watch('current', { immediate: true, deep: true })
  private onCurrentChange(val) {
    this.selectedKeys = this.current
  }
}
